// ── 출퇴근 년/월 셀렉트 옵션 훅 (2026-09-01 사용자 명세) ─────────────────────────
// "데이터가 있는 년·월"만 셀렉트에 띄운다 (+ 현재 월은 데이터 없어도 항상 포함 — 이번 달 조회 보장).
// API 미지원 화면(통합 메뉴 등)이나 조회 실패 시엔 기존 [작년/올해/내년 × 1~12월] 폴백 유지.
import { useEffect, useMemo, useState } from 'react';
import { nowKST } from '../../../utils/date';
import { apiClient } from '../../../api/apiClient';

export function useAvailableMonths({ attendancePath, includeResigned }) {
  const now = nowKST();
  const curYear = now.getUTCFullYear();
  const curMonth = now.getUTCMonth() + 1;
  const currentYm = `${curYear}-${String(curMonth).padStart(2, '0')}`;

  const [available, setAvailable] = useState(null); // null = 폴백 모드

  useEffect(() => {
    let active = true;
    // 기존 /admin/attendance/:id 라우트와의 충돌을 피해 '-available-months' 접미 경로 사용
    const path = `${attendancePath}-available-months?include_resigned=${includeResigned ? 'true' : 'false'}`;
    apiClient.get(path)
      .then((res) => {
        if (!active) return;
        setAvailable(res.ok && Array.isArray(res.data?.months) ? res.data.months : null);
      })
      .catch(() => { if (active) setAvailable(null); });
    return () => { active = false; };
  }, [attendancePath, includeResigned]);

  return useMemo(() => {
    if (!available) {
      // 폴백: 기존 동작 그대로 (전후 1년 + 12개월)
      return {
        yearOptions: (year) => [year - 1, year, year + 1],
        monthsForYear: () => Array.from({ length: 12 }, (_, i) => i + 1),
      };
    }
    const ymSet = new Set([...available, currentYm]);
    const byYear = new Map();
    for (const ym of ymSet) {
      const y = Number(ym.slice(0, 4));
      const m = Number(ym.slice(5, 7));
      if (!byYear.has(y)) byYear.set(y, new Set());
      byYear.get(y).add(m);
    }
    const years = [...byYear.keys()].sort((a, b) => b - a);
    return {
      yearOptions: () => years,
      monthsForYear: (y) => [...(byYear.get(y) || new Set([1]))].sort((a, b) => a - b),
    };
  }, [available, currentYm]);
}
